export enum ModalType {
  action = "action",
  success = "success",
  error = "error",
  confirmation = "confirmation",
  send = "send",
  downloadError = "downloadError",
  guidedTour = "guidedTour"
}

export enum ModalIconType {
  success = "success",
  caution = "caution",
  delete = "delete",
  inspect = "inspect",
  leave = "leave",
  question = "question",
  reverse = "reverse",
  validate = "validate",
  send = "send",
  downloadError = "downloadError"

}

export enum ModalButtonColor {
  primary = "primary",
  secondary = "secondary",
  danger = "danger",
  info = "info"
}
